import '../../../stylesheets/dashboards/dashboards.css'
import '../../../stylesheets/dashboards/leaderboard.css'
import { useState, useEffect, useRef }                         from 'react'
import { resolveStackedClassForColor, resolveChangeSignage }   from '../../../services/leaderboard/main/main.js';
import { formatNumber, formatNumberTwoDecimal,
         formatPercent, formatDollar }                         from '../../../utilities/formatNumber.js';

const SummaryStats = (props) => {
    const {indsPrices, priceDataActiveFields, period, type} = props      

    return (
        <div className="summary-stats-container">
            {indsPrices.map((ipd) => (
                <div
                    key={ipd.id}
                    className={`summary-cell ${resolveStackedClassForColor(ipd[priceDataActiveFields.heat], "indices")}`}
                >
                    <div className="summary-cell-name">
                        {ipd.name}
                    </div>
                    <div className="summary-cell-price">
                        ${formatNumberTwoDecimal(ipd.priceCurrent)}
                    </div>
                    <div className="summary-cell-change">
                        {/* symbol for change value displayed based on heat (+/-) and type ($/%) */}
                        {resolveChangeSignage(ipd[priceDataActiveFields.change], ipd[priceDataActiveFields.heat], type)}
                    </div>
                </div>
            ))}
        </div>        
    )
}

export default SummaryStats;